import { Link } from "react-router-dom";
import { Clock } from "lucide-react";
import StatusBadge from "@/components/StatusBadge";
import CaseImage from "@/components/CaseImage";
import { getCasePhotoUrls } from "@/lib/api";
import { daysUnderCareLabel } from "@/lib/dateUtils";

export default function CaseCard({ caseItem }) {
  const cover = getCasePhotoUrls(caseItem)[0];

  return (
    <Link
      to={`/cases/${caseItem.id}`}
      data-testid={`case-card-${caseItem.id}`}
      className="flex items-center gap-3 bg-amtm-surface border border-amtm-border rounded-lg p-3 active:scale-[0.99] transition-transform"
    >
      <CaseImage
        src={cover}
        alt={caseItem.animal_name}
        animalType={caseItem.animal_type}
        className="w-16 h-16 rounded-lg overflow-hidden shrink-0 object-cover"
      />
      <div className="flex-1 min-w-0">
        <div className="flex items-center justify-between gap-2">
          <h3 className="font-semibold text-amtm-text truncate" data-testid={`case-card-name-${caseItem.id}`}>
            #{caseItem.case_number} {caseItem.animal_name}
          </h3>
          <StatusBadge status={caseItem.status} />
        </div>
        <p className="text-sm text-amtm-textMuted truncate mt-0.5">{caseItem.case_history || "No details added yet"}</p>
        <p className="text-xs text-amtm-textMuted flex items-center gap-1 mt-1">
          <Clock className="h-3 w-3" /> {daysUnderCareLabel(caseItem)}
        </p>
      </div>
    </Link>
  );
}

